export default __webpack_public_path__ + "static/media/59t.6aa5893d.jpg";